import { loginUrl } from '@/config/env'

export function redirectToLogin(locale: string, redirectUrl?: string) {
  window.location.href = loginUrl(locale, redirectUrl)
}
